// Some configs to change easy the timings in the experience
export const CONFIG = {
  AMOUNT_OF_ITEMS_BEFORE_MATCHING: 3,
  CONFIRM_SELECTION_EXPLORE_IN_SECONDS: 2.5,
  CASE_GO_AWAY_IN_SECONDS: 18,
  RESET_EXPLORE_IN_SECONDS: 6,
  SCREEN_WIDTH_PERCENTAGE: 90,
};
